export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?w=2400&q=80&auto=format&fit=crop",
  expertise: [
    "https://images.unsplash.com/photo-1763485956292-7b9bed7b3c10?w=1200&q=80&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?w=1200&q=80&auto=format&fit=crop",
    "https://images.pexels.com/photos/10919439/pexels-photo-10919439.jpeg?auto=compress&cs=tinysrgb&w=1200",
  ],
  emotional: "https://images.pexels.com/photos/34887751/pexels-photo-34887751.jpeg?auto=compress&cs=tinysrgb&w=2400",
};

export const LOGOS = {
  horizontal: "/assets/logo-horizontal-t.png",
  horizontalNegativ: "/assets/logo-horizontal-negativ-t.png",
  wordmark: "/assets/logo-wortmarke-t.png",
  negativ: "/assets/logo-negativ-t.png",
  stacked: "/assets/logo-stacked-t.png",
};

// Uploaded files are stored as relative API paths (/api/files/{id}) — resolve them against the backend URL
export const resolveImg = (src) =>
  src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;
